import Box from '@mui/material/Box';
import MuiInputLabel from '@mui/material/InputLabel';
import MuiListItemButton from '@mui/material/ListItemButton';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';

// This might be better within the default theme style, but will need to check the entire app for ListItem usage.
export const ListItem = withStyles(MuiListItemButton, ({ spacing, palette }: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    marginBottom: spacing(1),
    borderRadius: spacing(0.5),
    margin: 0,

    backgroundColor: palette.common.white,
    boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12);',

    '&.Mui-selected, &.Mui-selected:hover, &:hover': {
      backgroundColor: 'rgba(222, 247, 255, 1)',
    },

    '&.Mui-disabled': {
      boxShadow: 'none',
      backgroundColor: palette.primary.lightest,
    },
  },
  selected: {},
  disabled: {
    boxShadow: 'none',
    backgroundColor: palette.primary.lightest,
  },
  dense: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

export const InputLabel = withStyles(MuiInputLabel, ({ palette, spacing }: Theme) => ({
  root: {
    color: palette.text.primary,
    marginBottom: spacing(1),
  },
}));

export const Section = withStyles(Box, ({ spacing }: Theme) => ({
  root: {
    marginBottom: spacing(4),
  },
}));

export const Control = withStyles(Box, ({ spacing }: Theme) => ({
  root: {
    textAlign: 'left',
    paddingBottom: spacing(2),
  },
}));

export const Container = withStyles(Box, {
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});
